import validator from 'validator';

const languges = validator.isAlphaLocales

export const isValidEmail = (email) => {
    
}
export const isValidPhoneNumber = (phoneNumber) => {
    return validator.isMobilePhone(phoneNumber)
}

export const isValidString = (string) => {
   
}

export const isPostalCode = (postalCode) => {
    return validator.isPostalCode(postalCode, 'any')
}

